
<div #quotesTable>
  @if (loading) {
    <div class="loading">
      <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
    </div>
  }

  <!-- desktop template -->
  <div *appIsDesktop>
    @if (!loading && !noResults) {
      <div id="quote-table-container">
        <ds-table mat-table [dataSource]="quotesList" [displayedColumns]="displayedColumns">
          <ng-container matColumnDef="accountName">
            <th mat-header-cell *matHeaderCellDef> {{ appStrings.quoteSearch_customerName }} </th>
            <td mat-cell *matCellDef="let quote;let i = dataIndex" [id]="'customerName_'+i" > {{ quote.accountName }} </td>
          </ng-container>
          <ng-container matColumnDef="bpNumber">
            <th mat-header-cell *matHeaderCellDef> {{ appStrings.quoteSearch_bpNumber }} </th>
            <td mat-cell *matCellDef="let quote;let i = dataIndex" [id]="'bpNumber_'+i"> {{ quote.bpNumber }} </td>
          </ng-container>
          <ng-container matColumnDef="confidenceToClosePercentageId">
            <th mat-header-cell *matHeaderCellDef> {{ appStrings.quoteSearch_confidencePct }} </th>
            <td mat-cell *matCellDef="let quote;let i = dataIndex" [id]="'confidence_'+i"> {{ confidenceToCloseNames[confidenceToClose[quote.confidenceToClosePercentageId]] }} </td>
          </ng-container>
          <ng-container matColumnDef="quoteNumber">
            <th mat-header-cell *matHeaderCellDef> {{ appStrings.quoteSearch_quoteNumber }} </th>
            <td mat-cell *matCellDef="let quote;let i = dataIndex" [id]="'number_'+i"> {{ quote.quoteNumber }} </td>
          </ng-container>
          <ng-container matColumnDef="expiredDate">
            <th mat-header-cell *matHeaderCellDef> {{ appStrings.quoteSearch_expireDate }} </th>
            <td mat-cell *matCellDef="let quote;let i = dataIndex" [id]="'expireDate_'+i"> {{ quote.expiredDate | date: dateFormat }} </td>
          </ng-container>
          <ng-container matColumnDef="total">
            <th mat-header-cell *matHeaderCellDef> {{ appStrings.label_total }} </th>
            <td mat-cell *matCellDef="let quote;let i = dataIndex" [id]="'total_'+i"> {{ quote.total | currency: quote.currencySign }} </td>
          </ng-container>
          <ng-container matColumnDef="view">
            <th mat-header-cell *matHeaderCellDef></th>
            <td class="edit-quote" mat-cell *matCellDef="let quote;let i = dataIndex" [id]="'view_'+i">
              <ds-button class="view-quote-buton" size="medium" type="tertiary" variant="label-icon" icon="visibility" [label]="appStrings.button_view"
                (onClick)="goToQuoteDetails(quote)" iconStyle="material-icons-outlined" iconPosition="left">
              </ds-button>
            </td>
          </ng-container>
        </ds-table>
      </div>
    }
  </div>

  <!-- mobile template -->
  <div *appIsMobile>
    @if (!loading && !noResults) {
      <div id="quote-table-container">
        @for (quote of quotesList; track quote; let i = $index) {
          <mat-expansion-panel class="mobile-card two-columns grey blue-border tall" [expanded]="false">
            <mat-expansion-panel-header>
              <mat-panel-title id="quote-card-header-container" class="card-header-container">
                <span class="card-header">
                  <span id="quote-card-title" class="title">
                    {{ quote.accountName }}
                  </span>
                  <span id="quote-card-subtitle" class="subtitle">
                    {{ quote.bpNumber }}
                  </span>
                </span>
                <span class="card-header-action">
                  <ds-button class="view-quote-buton" size="medium" type="tertiary" variant="icon-only" icon="visibility" (onClick)="goToQuoteDetails(quote)"
                    iconStyle="material-icons-outlined" [id]="'view_'+i">
                  </ds-button>
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ds-divider></ds-divider>
            <div class="content">
              <div class="row">
                <div class="column">
                  <typography [id]="'confidence_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.quoteSearch_confidencePct }} </typography>
                  <typography [id]="'confidence_'+i" variant="body-2" weight="medium"> {{ confidenceToCloseNames[confidenceToClose[quote.confidenceToClosePercentageId]] }} </typography>
                </div>
                <div class="column">
                  <typography [id]="'quoteNumber_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.quoteSearch_quoteNumber }} </typography>
                  <typography [id]="'quoteNumber_'+i" variant="body-2" weight="medium"> {{ quote.quoteNumber }} </typography>
                </div>
              </div>
              <div class="row">
                <div class="column">
                  <typography [id]="'expireDate_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.quoteSearch_expireDate }} </typography>
                  <typography [id]="'expireDate_'+i" variant="body-2" weight="medium"> {{ quote.expiredDate | date: dateFormat }} </typography>
                </div>
                <div class="column">
                  <typography [id]="'total_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.label_total }} </typography>
                  <typography [id]="'total_'+i" class="project-types" variant="body-2" weight="medium"> {{ quote.total | currency: quote.currencySign }}</typography>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        }
      </div>
    }
  </div>

  @if (noResults) {
    <div id="noResults" class="no-results">
      <typography variant="mat-subtitle-1" weight="regular">
        {{ appStrings.leads_noResults }}
      </typography>
    </div>
  }
</div>